@import "./../../styles/variables";

.smart-country-selector {
  &-widget {
    background-color: $svs-white;
    left: 0;
    margin: 0 153px;
    padding: 0 10px 20px;
    position: fixed;
    right: 0;
    top: 200px;
    z-index: 101;

    @media (max-width: 1100px) {
      margin: 0 auto;
      width: 90%;
    }

    @media (max-width: 780px) {
      height: 75%;
      top: 125px;
      overflow: scroll;
    }

    &__overlay {
      background-color: $svs-anthracite-grey;
      bottom: 0;
      height: 100%;
      left: 0;
      pointer-events: unset;
      position: fixed;
      transition: background-color 0.3s linear;
      top: 0;
      opacity: 0.7;
      width: 100vw;
      z-index: 100;

      @media (max-width: 780px) {
        height: 100vh;
      }
    }
  }
}
